import { render, staticRenderFns } from "./iconDetail.vue?vue&type=template&id=fcf7e78e&"
import script from "./iconDetail.vue?vue&type=script&lang=js&"
export * from "./iconDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports